module.exports = __webpack_public_path__ + "static/media/beu-logotext.1f241044.png";